import React from 'react'
import OrderItemsTable from '../../tables/OrderItemsTable'
import SectionTitle from '../../ui/SectionTitle'
import { ShoppingBagIcon } from '@heroicons/react/24/outline'
import { ProductSearchInput } from '../shared'
import type { OrderDetail } from '../../../types/pendingOrdersFormTypes'
import type { Product } from '../../../types/orderFormTypes'

interface PendingOrdersProductsSectionProps {
  orderDetail?: OrderDetail | null
  lineItems?: OrderDetail['lineItems']
  hideProductSection: boolean
  editable?: boolean
  clienteNeto: boolean
  productDetails: { [key: string]: any }
  loadingDetails: { [key: string]: boolean }
  expandedCombos: { [key: string]: boolean }
  onToggleCombo: (productId: string) => void
  onQuantityChange?: (index: number, quantity: number) => void
  onRemoveProduct?: (index: number) => void
  searchTerm?: string
  searchResults?: Product[]
  isSearching?: boolean
  showResults?: boolean
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSelectProduct?: (product: Product) => void
  onSearchFocus?: () => void
  onSearchBlur?: () => void
  calculateTotals: (items: any[]) => { subtotal: string; discount: string; taxes: string; shipping: string; total: string }
}

export const PendingOrdersProductsSection: React.FC<PendingOrdersProductsSectionProps> = ({
  orderDetail,
  lineItems,
  hideProductSection,
  editable = false,
  clienteNeto,
  productDetails,
  loadingDetails,
  expandedCombos,
  onToggleCombo,
  onQuantityChange,
  onRemoveProduct,
  searchTerm = '',
  searchResults = [],
  isSearching = false,
  showResults = false,
  onSearchChange,
  onSelectProduct,
  onSearchFocus,
  onSearchBlur,
  calculateTotals
}) => {
  if (hideProductSection) return null

  const rows = lineItems ?? orderDetail?.lineItems ?? []

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <SectionTitle icon={ShoppingBagIcon} noMargin>Productos del Pedido</SectionTitle>
        {editable && onSearchChange && onSelectProduct && onSearchFocus && onSearchBlur && (
          <ProductSearchInput
            searchTerm={searchTerm}
            searchResults={searchResults}
            isSearching={isSearching}
            showResults={showResults}
            onSearchChange={onSearchChange}
            onSelectProduct={onSelectProduct}
            onFocus={onSearchFocus}
            onBlur={onSearchBlur}
          />
        )}
      </div>

      <OrderItemsTable
        lineItems={rows}
        productDetails={productDetails}
        loadingDetails={loadingDetails}
        expandedCombos={expandedCombos}
        mode={editable ? 'edit' : 'view'}
        formDataStatus={orderDetail?.status}
        onQuantityChange={onQuantityChange || (() => undefined)}
        onRemoveProduct={onRemoveProduct || (() => undefined)}
        onDiscountChange={() => undefined}
        onPriceChange={() => undefined}
        onToggleCombo={onToggleCombo}
        calculateTotals={calculateTotals}
        shippingCost={orderDetail?.envio || '0'}
        clienteNeto={clienteNeto}
        allowPriceEdit={false}
        allowDiscountEdit={false}
      />
    </div>
  )
}
